module.exports = __webpack_public_path__ + "img/fexspace-user.66ceb285.svg";